import React, { useEffect, useRef, useState } from "react";
import "./Gallery.css";
import { apiFetch } from "../../helpers/api";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const carouselRef = useRef(null);

  const fetchGalleryImages = async () => {
    try {
      const data = await apiFetch("/api/gallery");
      if (Array.isArray(data)) {
        setImages(data);
      } else {
        setImages([]);
      }
    } catch (err) {
      console.error("Failed to fetch gallery images:", err);
      setImages([]);
    }
  };

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  useEffect(() => {
    const carouselElement = carouselRef.current;

    if (!carouselElement || images.length <= 1 || !window.bootstrap?.Carousel) {
      return undefined;
    }

    const carouselInstance = window.bootstrap.Carousel.getOrCreateInstance(
      carouselElement,
      {
        interval: 6000,
        ride: "carousel",
        pause: false,
        touch: true,
        wrap: true,
      }
    );

    carouselInstance.cycle();

    return () => {
      carouselInstance.dispose();
    };
  }, [images.length]);

  const displayImages =
    images.length > 0
      ? images
      : [{ imageUrl: "/images/galleryPlaceholder.png" }];

  return (
    <section className="about-gallery">
      <div
        id="carouselExampleIndicators"
        ref={carouselRef}
        className="carousel slide carousel-fade gallery-carousel"
        data-bs-ride="carousel"
        data-bs-interval="6000"
        data-bs-pause="false"
        data-bs-touch="true"
      >
        <div className="carousel-indicators">
          {displayImages.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={idx}
              className={idx === 0 ? "active" : ""}
              aria-current={idx === 0 ? "true" : undefined}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner">
          {displayImages.map((img, idx) => (
            <div
              key={idx}
              className={`carousel-item${idx === 0 ? " active" : ""}`}
            >
              <div className="gallery-slide">
                <img
                  src={img?.imageUrl || "/images/galleryPlaceholder.png"}
                  className="gallery-image"
                  alt={`Slide ${idx + 1}`}
                  loading={idx === 0 ? undefined : "lazy"}
                />
              </div>
            </div>
          ))}
        </div>

        {displayImages.length > 1 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              />
              <span className="visually-hidden">Next</span>
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default Gallery;
